export var noVisitorMessage = 'flagship Visitor not initialized.';
export var noVisitorDefault = 'fsVisitor not initialized, returns default value';